export const feUrl = '/qdd/admin';
  // export const reBase = 'http://127.0.0.1:43100';
 // export const reBase = 'https://admin.tujianjian.com';
 // export const reBase = 'http://101.200.121.190:8081';
export const reBase = '';
export const reUrl = reBase + '/trc20/qdd/manager';

export default {
    feUrl,
    reBase,
    reUrl
}
// 查询团队数据
